module.exports = __webpack_public_path__ + "assets/CIntersectXDetailed.4a7ab080f9a7db2f314a145867c5a3df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CIntersectXDetailed.png
// module id = 474
// module chunks = 0